import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import {
  Music, Globe, Play, Share2, CheckCircle, Crown, Radio,
  MapPin, ExternalLink, Loader2, ChevronLeft, BarChart3, Users, Disc3
} from "lucide-react";
import { useAuth, BACKEND_URL } from "../context/AuthContext";
import Header from "../components/Header";
import Footer from "../components/Footer";
import SEO from "../components/SEO";

const SocialIcon = ({ type }) => {
  const icons = {
    instagram: (
      <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
    ),
    tiktok: (
      <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current"><path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/></svg>
    ),
    facebook: (
      <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
    ),
    twitter: (
      <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
    ),
    spotify: (
      <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current"><path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/></svg>
    ),
    soundcloud: (
      <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current"><path d="M1.175 12.225c-.051 0-.094.046-.101.1l-.233 2.154.233 2.105c.007.058.05.098.101.098.05 0 .09-.04.099-.098l.255-2.105-.27-2.154c-.009-.06-.05-.1-.1-.1m-.899.828c-.06 0-.091.037-.104.094L0 14.479l.172 1.282c.013.06.045.094.104.094.057 0 .09-.034.104-.094l.199-1.282-.199-1.332c-.014-.057-.047-.094-.104-.094m1.8-.744c-.064 0-.11.045-.117.108l-.21 2.07.21 2.015c.007.064.053.108.116.108.065 0 .11-.044.12-.108l.235-2.015-.235-2.07c-.01-.063-.055-.108-.12-.108m.899-.165c-.073 0-.12.05-.127.114l-.188 2.235.188 2.059c.007.071.054.12.127.12.072 0 .119-.049.129-.12l.21-2.059-.21-2.235c-.01-.064-.057-.114-.129-.114m.901-.122c-.077 0-.135.06-.139.135l-.165 2.357.165 2.09c.004.074.062.13.139.13.076 0 .134-.056.14-.13l.185-2.09-.185-2.357c-.006-.075-.064-.135-.14-.135m.9-.044c-.085 0-.149.063-.155.147l-.145 2.401.145 2.105c.006.083.07.147.155.147.083 0 .148-.064.155-.147l.162-2.105-.162-2.401c-.007-.084-.072-.147-.155-.147m.903.01c-.089 0-.161.072-.164.16l-.121 2.391.121 2.087c.003.09.075.161.164.161.09 0 .161-.071.168-.161l.135-2.087-.135-2.391c-.007-.088-.078-.16-.168-.16m.899-.167c-.095 0-.175.079-.179.176l-.098 2.558.098 2.078c.004.097.084.175.179.175s.174-.078.181-.175l.111-2.078-.111-2.558c-.007-.097-.086-.176-.181-.176m.903-.032c-.101 0-.182.084-.189.189l-.081 2.59.081 2.069c.007.105.088.189.189.189.1 0 .183-.084.19-.189l.091-2.069-.091-2.59c-.007-.105-.09-.189-.19-.189m.901-.015c-.104 0-.195.09-.199.2l-.058 2.605.058 2.06c.004.109.095.2.199.2.105 0 .194-.091.201-.2l.066-2.06-.066-2.605c-.007-.11-.096-.2-.201-.2m3.674-.556c-.204 0-.38.086-.529.192-.165-1.843-1.74-3.278-3.638-3.278-.481 0-.946.1-1.374.271-.16.063-.214.127-.216.253v6.73c.003.131.104.236.234.247h5.523c1.168 0 2.117-.949 2.117-2.118 0-1.17-.949-2.118-2.117-2.118m-5.573-.057c-.108 0-.2.095-.204.209l-.055 2.663.055 2.051c.004.114.096.209.204.209.11 0 .2-.095.207-.209l.063-2.051-.063-2.663c-.007-.114-.098-.209-.207-.209"/></svg>
    ),
    youtube: (
      <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current"><path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
    ),
  };
  return icons[type] || null;
};

const ArtistProfilePage = () => {
  const { slug } = useParams();
  const { user, token } = useAuth();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [claiming, setClaiming] = useState(false);
  const [claimMsg, setClaimMsg] = useState(null);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await fetch(`${BACKEND_URL}/api/artists/${slug}`);
        if (res.ok) {
          setProfile(await res.json());
        } else {
          setNotFound(true);
        }
      } catch {
        setNotFound(true);
      } finally {
        setLoading(false);
      }
    };
    fetchProfile();
  }, [slug]);

  const handleClaim = async () => {
    setClaiming(true);
    try {
      const res = await fetch(`${BACKEND_URL}/api/artists/${slug}/claim`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      });
      const data = await res.json();
      if (res.ok) {
        setClaimMsg({ type: "success", text: data.message });
        setProfile(p => ({ ...p, is_claimed: true }));
      } else {
        setClaimMsg({ type: "error", text: data.detail || "Claim failed" });
      }
    } catch {
      setClaimMsg({ type: "error", text: "Network error" });
    } finally {
      setClaiming(false);
    }
  };

  const handleShare = async () => {
    const url = window.location.href;
    const text = `Check out ${profile?.artist_name} on DJsandMCMedia`;
    if (navigator.share) {
      try { await navigator.share({ title: text, url }); } catch {}
    } else {
      navigator.clipboard?.writeText(url);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-purple-400" />
      </div>
    );
  }

  if (notFound) {
    return (
      <div className="min-h-screen bg-[#0a0a0a] text-white">
        <Header />
        <div className="flex flex-col items-center justify-center min-h-[70vh] px-6">
          <Music className="w-16 h-16 text-white/10 mb-4" />
          <h1 className="text-2xl font-bold mb-2">Artist Not Found</h1>
          <p className="text-white/40 mb-6">This profile doesn't exist yet.</p>
          <Link to="/discover" className="text-purple-400 hover:text-purple-300 font-medium">
            Browse Artists
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  const p = profile;
  const socials = [
    { type: "instagram", url: p.instagram },
    { type: "tiktok", url: p.tiktok },
    { type: "facebook", url: p.facebook },
    { type: "twitter", url: p.twitter },
    { type: "spotify", url: p.spotify },
    { type: "soundcloud", url: p.soundcloud },
    { type: "youtube", url: p.youtube },
  ].filter(s => s.url);

  const stats = p.play_stats || {};
  const canClaim = user && !p.is_claimed && user.email?.toLowerCase() === p.email?.toLowerCase();

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white">
      <SEO
        title={`${p.artist_name} — DJsandMCMedia`}
        description={p.bio || `Listen to ${p.artist_name} on DJsandMCMedia. ${p.genre_tags?.length ? `Genres: ${p.genre_tags.join(", ")}.` : ""} ${p.location ? `Based in ${p.location}.` : ""} Discover music, explore their profile, and connect.`}
        image={p.photo_url || "/og-image.png"}
        type="profile"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "MusicGroup",
          "name": p.artist_name,
          "url": window.location.href,
          "image": p.photo_url || undefined,
          "description": p.bio || `Independent artist on DJsandMCMedia`,
          "genre": p.genre_tags || undefined,
          ...(p.location ? { "location": { "@type": "Place", "name": p.location } } : {}),
          ...(p.social_links ? { "sameAs": Object.values(p.social_links).filter(Boolean) } : {}),
          ...(p.approved_tracks?.length ? { "track": p.approved_tracks.map(t => ({ "@type": "MusicRecording", "name": t })) } : {}),
        }}
      />
      <Header />

      {/* Hero / Profile Header */}
      <section className="pt-24 pb-12 px-6">
        <div className="max-w-4xl mx-auto">
          <Link to="/discover" className="inline-flex items-center gap-1.5 text-white/40 hover:text-white/70 text-sm mb-8 transition">
            <ChevronLeft className="w-4 h-4" /> Back to Discover
          </Link>

          <div className="flex flex-col sm:flex-row gap-8 items-start">
            {/* Photo */}
            <div className="w-40 h-40 sm:w-48 sm:h-48 rounded-2xl overflow-hidden bg-white/5 shrink-0" data-testid="artist-photo">
              {p.photo_url ? (
                <img src={p.photo_url} alt={p.artist_name} className="w-full h-full object-cover" />
              ) : (
                <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-purple-500/20 to-pink-500/20">
                  <Music className="w-16 h-16 text-white/20" />
                </div>
              )}
            </div>

            {/* Info */}
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-3 mb-1 flex-wrap">
                <h1 className="text-3xl sm:text-4xl font-bold" data-testid="artist-name">{p.artist_name}</h1>
                {p.is_member && (
                  <span className="inline-flex items-center gap-1 bg-amber-400/20 text-amber-400 text-xs font-bold px-2.5 py-1 rounded-full border border-amber-400/30" data-testid="member-badge">
                    <Crown className="w-3 h-3" /> MEMBER
                  </span>
                )}
                {stats.in_rotation && (
                  <span className="inline-flex items-center gap-1 bg-green-500/20 text-green-400 text-xs font-bold px-2.5 py-1 rounded-full border border-green-500/30" data-testid="rotation-badge">
                    <Radio className="w-3 h-3" /> IN ROTATION
                  </span>
                )}
              </div>

              {/* Genre Tags */}
              {p.genre_tags?.length > 0 && (
                <div className="flex gap-2 flex-wrap mb-3" data-testid="genre-tags">
                  {p.genre_tags.map((tag, i) => (
                    <span key={i} className="text-xs bg-white/5 text-white/50 px-2.5 py-1 rounded-full border border-white/8">
                      {tag}
                    </span>
                  ))}
                </div>
              )}

              {/* Location + Verified Check */}
              {p.location && (
                <p className="text-white/40 text-sm flex items-center gap-1.5 mb-3">
                  <MapPin className="w-3.5 h-3.5" /> {p.location}
                  {p.gender === "male" && (
                    <svg viewBox="0 0 24 24" className="w-4 h-4 shrink-0" data-testid="verified-blue">
                      <path d="M9 12l2 2 4-4" stroke="#3b82f6" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                      <circle cx="12" cy="12" r="10" fill="#3b82f6" fillOpacity="0.15" stroke="#3b82f6" strokeWidth="1.5"/>
                    </svg>
                  )}
                  {p.gender === "female" && (
                    <svg viewBox="0 0 24 24" className="w-4 h-4 shrink-0" data-testid="verified-pink">
                      <path d="M9 12l2 2 4-4" stroke="#ec4899" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                      <circle cx="12" cy="12" r="10" fill="#ec4899" fillOpacity="0.15" stroke="#ec4899" strokeWidth="1.5"/>
                    </svg>
                  )}
                </p>
              )}

              {/* Bio */}
              {p.bio && (
                <p className="text-white/60 text-sm leading-relaxed mb-2 max-w-xl" data-testid="artist-bio">{p.bio}</p>
              )}

              {/* Tagline */}
              <p className="text-white/25 text-xs italic mb-4" data-testid="artist-tagline">Building a global audience through DJsandMCMedia.</p>

              {/* Social Links */}
              {socials.length > 0 && (
                <div className="flex gap-3 mb-4">
                  {socials.map(s => (
                    <a
                      key={s.type}
                      href={s.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-9 h-9 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-white/50 hover:text-white hover:border-white/30 transition"
                      data-testid={`social-${s.type}`}
                    >
                      <SocialIcon type={s.type} />
                    </a>
                  ))}
                  {p.website && (
                    <a
                      href={p.website}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-9 h-9 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-white/50 hover:text-white hover:border-white/30 transition"
                      data-testid="social-website"
                    >
                      <ExternalLink className="w-4 h-4" />
                    </a>
                  )}
                </div>
              )}

              {/* Action Buttons */}
              <div className="flex gap-3 flex-wrap">
                <button
                  onClick={handleShare}
                  className="flex items-center gap-2 bg-purple-500 hover:bg-purple-600 text-white font-semibold px-5 py-2.5 rounded-xl transition text-sm"
                  data-testid="share-profile-btn"
                >
                  <Share2 className="w-4 h-4" /> Share Profile
                </button>

                {canClaim && (
                  <button
                    onClick={handleClaim}
                    disabled={claiming}
                    className="flex items-center gap-2 bg-amber-400/20 hover:bg-amber-400/30 text-amber-400 border border-amber-400/30 font-semibold px-5 py-2.5 rounded-xl transition text-sm disabled:opacity-50"
                    data-testid="claim-profile-btn"
                  >
                    <CheckCircle className="w-4 h-4" /> {claiming ? "Claiming..." : "Claim This Profile"}
                  </button>
                )}
              </div>

              {claimMsg && (
                <p className={`text-sm mt-3 ${claimMsg.type === "success" ? "text-green-400" : "text-red-400"}`}>
                  {claimMsg.text}
                </p>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Member Stats (locked for free) */}
      {p.is_member && (stats.total_plays > 0 || stats.in_rotation) ? (
        <section className="pb-10 px-6">
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
              <div className="bg-white/[0.03] border border-white/10 rounded-2xl p-5 text-center" data-testid="stat-plays">
                <BarChart3 className="w-5 h-5 text-purple-400 mx-auto mb-2" />
                <p className="text-2xl font-bold text-white">{stats.total_plays?.toLocaleString() || 0}</p>
                <p className="text-white/40 text-xs mt-1">Total Plays</p>
              </div>
              <div className="bg-white/[0.03] border border-white/10 rounded-2xl p-5 text-center" data-testid="stat-listeners">
                <Users className="w-5 h-5 text-purple-400 mx-auto mb-2" />
                <p className="text-2xl font-bold text-white">{stats.total_listeners?.toLocaleString() || 0}</p>
                <p className="text-white/40 text-xs mt-1">Total Listeners</p>
              </div>
              <div className="bg-white/[0.03] border border-white/10 rounded-2xl p-5 text-center col-span-2 sm:col-span-1" data-testid="stat-rotation">
                <Radio className="w-5 h-5 text-green-400 mx-auto mb-2" />
                <p className="text-2xl font-bold text-white">{stats.in_rotation ? "Active" : "Inactive"}</p>
                <p className="text-white/40 text-xs mt-1">Rotation Status</p>
              </div>
            </div>
          </div>
        </section>
      ) : !p.is_member && (
        <section className="pb-10 px-6">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white/[0.02] border border-white/8 rounded-2xl p-6 text-center" data-testid="stats-locked">
              <Crown className="w-8 h-8 text-amber-400/40 mx-auto mb-3" />
              <h3 className="text-white/60 font-medium mb-1">Play Stats & Analytics</h3>
              <p className="text-white/30 text-sm mb-4">Upgrade to Artist Membership to unlock play counts, listener reach, and rotation status.</p>
              <Link
                to="/submit"
                className="inline-flex items-center gap-2 bg-amber-400/20 text-amber-400 border border-amber-400/30 px-5 py-2.5 rounded-xl text-sm font-semibold hover:bg-amber-400/30 transition"
              >
                <Crown className="w-4 h-4" /> Learn About Artist Membership
              </Link>
            </div>
          </div>
        </section>
      )}

      {/* Tracks */}
      <section className="pb-24 px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-xl font-bold mb-6 flex items-center gap-2">
            <Music className="w-5 h-5 text-purple-400" /> Tracks on DJsandMCMedia
          </h2>

          {p.tracks?.length > 0 ? (
            <div className="space-y-3">
              {p.tracks.map((track, i) => {
                // Determine if track is in rotation (played in last 7 days)
                const isInRotation = stats.in_rotation && p.is_member;
                return (
                  <div
                    key={i}
                    className="flex items-center gap-4 bg-white/[0.03] border border-white/8 rounded-xl p-4 hover:bg-white/[0.05] transition group"
                    data-testid={`track-${i}`}
                  >
                    {/* Play Button */}
                    <a
                      href={track.streaming_link || "#"}
                      target={track.streaming_link ? "_blank" : undefined}
                      rel="noopener noreferrer"
                      className="w-11 h-11 rounded-full bg-purple-500/20 hover:bg-purple-500/30 flex items-center justify-center text-purple-400 transition shrink-0"
                      data-testid={`play-track-${i}`}
                    >
                      <Play className="w-5 h-5 ml-0.5" />
                    </a>

                    {/* Album Art */}
                    <div className="w-12 h-12 rounded-lg overflow-hidden bg-white/5 shrink-0">
                      {track.album_art ? (
                        <img src={track.album_art} alt={track.track_title} className="w-full h-full object-cover" />
                      ) : (
                        <div className="w-full h-full flex items-center justify-center">
                          <Disc3 className="w-5 h-5 text-white/20" />
                        </div>
                      )}
                    </div>

                    {/* Track Info */}
                    <div className="flex-1 min-w-0">
                      <h3 className="text-white font-medium text-sm truncate">{track.track_title}</h3>
                      <p className="text-white/40 text-xs truncate">{track.genre || ""}</p>
                    </div>

                    {/* Status Badges */}
                    <div className="flex items-center gap-2 shrink-0">
                      {track.featured && (
                        <span className="text-[10px] font-bold px-2.5 py-1 rounded-full bg-yellow-500/15 text-yellow-400 border border-yellow-500/25" data-testid={`badge-featured-${i}`}>
                          FEATURED
                        </span>
                      )}
                      {isInRotation && (
                        <span className="text-[10px] font-bold px-2.5 py-1 rounded-full bg-green-500/15 text-green-400 border border-green-500/25" data-testid={`badge-rotation-${i}`}>
                          IN ROTATION
                        </span>
                      )}
                      <span className="text-[10px] font-bold px-2.5 py-1 rounded-full bg-emerald-500/15 text-emerald-400 border border-emerald-500/25" data-testid={`badge-approved-${i}`}>
                        APPROVED
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <p className="text-white/30 text-sm">No approved tracks yet.</p>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ArtistProfilePage;
